import { Routes } from '@angular/router';
import { AuthGuardService } from './core/services/auth-guard.service';
const ɵ0 = () => import("./login/login.module.ngfactory").then(m => m.LoginModuleNgFactory), ɵ1 = () => import("./dms/dms.module.ngfactory").then(m => m.DmsModuleNgFactory), ɵ2 = () => import("./print-preview/print-preview.module.ngfactory").then(m => m.PrintPreviewModuleNgFactory);
const appRoutes = [
    {
        path: '',
        redirectTo: '/login',
        pathMatch: 'full',
    },
    {
        path: 'login',
        loadChildren: ɵ0,
    },
    {
        path: 'dms',
        canActivate: [AuthGuardService],
        loadChildren: ɵ1,
    },
    {
        path: 'printPreview',
        canActivate: [AuthGuardService],
        loadChildren: ɵ2
    }
];
export class AppRoutingModule {
}
export { ɵ0, ɵ1, ɵ2 };
